import PropTypes from 'prop-types';
import { useEffect, useRef } from 'preact/hooks';

import CoreRepHeader from '@distinct-components/navigation/coreRepHeader';
import {
  CoreWrapper,
  CorePageWrapper,
  CoreAlertWrapper,
  MockAlert,
  CoreHeaderWrapper,
  CoreWorkSpaceWrapper,
  CoreContentWrapper,
} from './CoreRepLayoutStyles';

const childrenPropTypes = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.func,
  PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ])),
]);

function CoreRepLayout({
  children,
  globalAlert,
}) {
  const topRef = useRef();
  useEffect(() => {
    topRef.current.scrollIntoView();
    document.body.style.backgroundColor = 'var(--background)';
  }, []);

  return (
    <CoreWrapper>
      <CorePageWrapper ref={topRef}>
        {globalAlert
        && (
        <CoreAlertWrapper>
          <MockAlert>{globalAlert}</MockAlert>
        </CoreAlertWrapper>
        )}
        <CoreHeaderWrapper globalAlert={globalAlert}>
          <CoreRepHeader />
        </CoreHeaderWrapper>
        <CoreWorkSpaceWrapper>
          <CoreContentWrapper>
            {children}
          </CoreContentWrapper>
        </CoreWorkSpaceWrapper>
      </CorePageWrapper>
    </CoreWrapper>
  );
}

CoreRepLayout.propTypes = {
  children: childrenPropTypes.isRequired,
  globalAlert: PropTypes.string,
};

CoreRepLayout.defaultProps = {
  globalAlert: null,
};

export default CoreRepLayout;
